import { ImageProcessingStatus as e, ListingImageCategory as t, PropertyImageCategory as n, UnitImageCategory as r } from "@maat/api-main/types";
//#region src/properties/gallery/galleryDraft.ts
var i = {
	property: n.General,
	unit: r.Bedroom
}, a = {
	deletes: [],
	keep: []
}, o = (e) => e.category === t.Cover, s = (t) => t.processing_status === e.Ready, c = (e) => `${e.owning_asset}:${e.category}`, l = (e, t) => e.sort_order - t.sort_order || e.id.localeCompare(t.id), u = {
	unit: 0,
	listing: 1,
	property: 2
}, d = (e, t) => (u[e.owning_asset] ?? 3) - (u[t.owning_asset] ?? 3) || l(e, t), f = (e) => [...e].filter(o).sort(d)[0]?.id ?? null, p = (e, t) => {
	let n = e.find((e) => e.id === t);
	return n ? e.filter((e) => c(e) === c(n)).sort(l) : [];
}, m = (e, t, n) => {
	let r = p(e, t), i = r.findIndex((e) => e.id === t), o = i + n;
	if (i < 0 || o < 0 || o >= r.length) return a;
	let s = [...r];
	return [s[i], s[o]] = [s[o], s[i]], {
		deletes: [],
		keep: s.map((e, t) => ({
			id: e.id,
			sort_order: t
		}))
	};
}, h = (e, t) => p(e, t).findIndex((e) => e.id === t) > 0, g = (e, t) => {
	let n = p(e, t), r = n.findIndex((e) => e.id === t);
	return r >= 0 && r < n.length - 1;
}, _ = (e, t) => m(e, t, -1), v = (e, t) => m(e, t, 1), y = (e, t) => {
	let n = e.find((e) => e.id === t);
	return !!n && s(n) && f(e) !== t;
}, b = (e, n, r, c = i[r]) => {
	if (!y(e, n)) return a;
	let l = [{
		id: n,
		sort_order: 0,
		category: t.Cover
	}], u = e.filter((e) => e.owning_asset === r && e.category === c).reduce((e, t) => Math.max(e, t.sort_order), -1) + 1, f = 1;
	for (let t of e.filter((e) => o(e) && e.id !== n).sort(d)) l.push(s(t) ? {
		id: t.id,
		sort_order: u++,
		category: c
	} : {
		id: t.id,
		sort_order: f++
	});
	return {
		deletes: [],
		keep: l
	};
}, x = {
	coverId: f,
	canMoveBackward: h,
	canMoveForward: g,
	canMakeCover: y,
	moveBackward: _,
	moveForward: v,
	makeCover: b,
	remove: (e, t, n) => {
		if (!e.some((e) => e.id === t)) return a;
		let r = e.filter((e) => e.id !== t);
		if (f(e) !== t || f(r) !== null) return {
			deletes: [t],
			keep: []
		};
		let i = r.filter(s).sort((e, t) => c(e).localeCompare(c(t)) || l(e, t))[0];
		return i ? {
			deletes: [t],
			keep: b(r, i.id, n).keep
		} : {
			deletes: [t],
			keep: []
		};
	}
};
//#endregion
export { i as DEMOTED_COVER_CATEGORY, x as galleryDraft };
